(function () {
  "use strict";

  function initQuiz(quiz) {
    if (!quiz) return;

    if (quiz.dataset.quizInitialized === "true") {
      return;
    }

    quiz.dataset.quizInitialized = "true";

    const screens = quiz.querySelectorAll(".quiz-screen");

    const progressBar = quiz.querySelector("[data-progress]");
    const progressContainer = quiz.querySelector("[data-progress-container]");

    const startButton = quiz.querySelector("[data-next-screen]");
    const goalContinueButton = quiz.querySelector("[data-continue-question]");
    const flavourContinueButton = quiz.querySelector("[data-continue-flavour]");
    const caffeineContinueButton = quiz.querySelector(
      "[data-continue-caffeine]",
    );

    const sportScreen = quiz.querySelector("[data-sport-screen]");
    const sportContinueButton = quiz.querySelector("[data-continue-sport]");
    const sportBackButton = quiz.querySelector("[data-back-sport]");

    /*
     * QUIZ STATE
     *
     * baseLine is the line chosen directly on Screen 2
     * (ENERGY / CREAM / SPORT / RESET / TASTING_PACK) and
     * is never mutated afterwards. The actual product line
     * used for the flavour screen + final result is always
     * recomputed from baseLine + sportLevel + caffeine via
     * getProductLine(), so going Back and changing an
     * earlier answer always produces the correct result.
     */
    const quizState = {
      currentScreen: 1,

      goal: null,
      baseLine: null,

      // Flavour is now single-select
      flavour: null,

      caffeine: null,

      // Sport extra question
      sportLevel: null,

      // Screen 5
      consumption: null,

      // Screen 6
      email: null,

      // Final recommendation key, e.g. "ENERGY_FRESH", "HYDRIZE_CITRUS",
      // "IGNITION_INTENSE", "RESET", "TASTING_PACK"
      result: null,
    };

    /*
     * PROGRESS
     */
    function updateProgress(screenNumber) {
      const totalScreens = 7;

      const progress = (screenNumber / totalScreens) * 100;

      if (progressBar) {
        progressBar.style.width = progress + "%";
      }

      if (progressContainer) {
        progressContainer.setAttribute("aria-valuenow", screenNumber);
      }
    }

    /*
     * SHOW SCREEN
     */
    function showScreen(screenNumber) {
      const targetScreen = quiz.querySelector(
        '[data-screen="' + screenNumber + '"]',
      );

      if (!targetScreen) {
        return;
      }

      screens.forEach(function (screen) {
        screen.classList.remove("is-active");
      });

      targetScreen.classList.add("is-active");

      quizState.currentScreen = screenNumber;

      updateProgress(screenNumber);

      const headerOffset = 20;

      const quizTop =
        quiz.getBoundingClientRect().top + window.scrollY - headerOffset;

      window.scrollTo({
        top: Math.max(quizTop, 0),
        behavior: "smooth",
      });
    }

    function showSportScreen() {
      if (!sportScreen) {
        return;
      }

      screens.forEach(function (screen) {
        screen.classList.remove("is-active");
      });

      sportScreen.classList.add("is-active");

      /*
       * Sport sub-level is considered STEP 3
       * for progress purposes.
       */
      quizState.currentScreen = 3;

      updateProgress(3);

      const headerOffset = 20;

      const quizTop =
        quiz.getBoundingClientRect().top + window.scrollY - headerOffset;

      window.scrollTo({
        top: Math.max(quizTop, 0),
        behavior: "smooth",
      });
    }

    /*
     * RESET QUIZ STATE
     */
    function resetQuizState() {
      quizState.currentScreen = 1;
      quizState.goal = null;
      quizState.baseLine = null;
      quizState.flavour = null;
      quizState.caffeine = null;
      quizState.sportLevel = null;
      quizState.consumption = null;
      quizState.email = null;
      quizState.result = null;
    }

    /*
     * PRODUCT LINE RESOLUTION
     *
     * Always derived fresh from the current state so that
     * going Back and changing an earlier answer (sport level,
     * caffeine tolerance) is always reflected correctly.
     *
     * SPORT  → advanced  = IGNITION
     *          amateur   = ENERGY
     *          recovery  = HYDRIZE
     *
     * ENERGY / CREAM + caffeine "little" → HYDRIZE
     * ENERGY / CREAM + caffeine "full"/"moderate" → unchanged
     *
     * RESET / TASTING_PACK are returned as-is (no flavour screen).
     */
    function getProductLine() {
      if (quizState.baseLine === "SPORT") {
        if (quizState.sportLevel === "advanced") return "IGNITION";
        // Changes Oscar 21-10: el amateur tambien pasa por la cafeina;
        // "poco o nada" le lleva a Hydrize como en Energy / Cream.
        if (quizState.sportLevel === "amateur") {
          return quizState.caffeine === "little" ? "HYDRIZE" : "ENERGY";
        }
        if (quizState.sportLevel === "recovery") return "HYDRIZE";
        return null;
      }

      if (quizState.baseLine === "ENERGY" || quizState.baseLine === "CREAM") {
        if (quizState.caffeine === "little") {
          return "HYDRIZE";
        }
        return quizState.baseLine;
      }

      return quizState.baseLine;
    }

    /*
     * FLAVOUR GROUPS
     *
     * Only one group of flavour options is shown at a time,
     * matching the resolved product line.
     */
    const flavourGroups = quiz.querySelectorAll("[data-flavour-group]");
    const flavourOptions = quiz.querySelectorAll(".quiz-flavour-option");

    function showFlavourGroup(line) {
      flavourGroups.forEach(function (group) {
        group.hidden = group.dataset.flavourGroup !== line;
      });

      flavourOptions.forEach(function (item) {
        item.classList.remove("is-selected");
      });

      quizState.flavour = null;

      if (flavourContinueButton) {
        flavourContinueButton.disabled = true;
      }
    }

    /*
     * SCREEN 1
     * INTRO → SCREEN 2
     */
    if (startButton) {
      startButton.addEventListener("click", function () {
        showScreen(2);
      });
    }

    /*
     * SCREEN 2
     * GOAL SELECTION
     */

    const goalOptions = quiz.querySelectorAll(".quiz-option");

    goalOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        goalOptions.forEach(function (item) {
          item.classList.remove("is-selected");
        });

        option.classList.add("is-selected");

        quizState.goal = option.dataset.answer;
        quizState.baseLine = option.dataset.line;

        /*
         * Reset values that belong to previous branches
         */
        quizState.sportLevel = null;
        quizState.flavour = null;
        quizState.caffeine = null;
        quizState.consumption = null;
        quizState.email = null;
        quizState.result = null;

        if (goalContinueButton) {
          goalContinueButton.disabled = false;
        }
      });
    });

    const backIntro = quiz.querySelector("[data-back-intro]");

    if (backIntro) {
      backIntro.addEventListener("click", function () {
        showScreen(1);
      });
    }

    /*
     * SCREEN 2 CONTINUE
     *
     * ENERGY / CREAM → CAFFEINE (screen 3)
     * SPORT → SPORT EXTRA QUESTION (skips caffeine)
     * RESET → SCREEN 6 (email)
     * TASTING PACK → SCREEN 7 (result)
     */
    if (goalContinueButton) {
      goalContinueButton.addEventListener("click", function () {
        if (!quizState.goal) return;

        if (quizState.goal === "reset") {
          quizState.result = "RESET";
          showScreen(6);
          return;
        }

        if (quizState.goal === "tasting-pack") {
          // Changes Oscar 21-10: tambien pasa por el email (se puede saltar).
          quizState.result = "TASTING_PACK";
          showScreen(6);

          return;
        }

        if (quizState.baseLine === "SPORT") {
          showSportScreen();

          return;
        }

        showScreen(3);
      });
    }

    const sportOptions = quiz.querySelectorAll(".quiz-sport-option");

    sportOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        sportOptions.forEach(function (item) {
          item.classList.remove("is-selected");
        });

        option.classList.add("is-selected");

        quizState.sportLevel = option.dataset.sportLevel;
        quizState.caffeine = null;
        caffeineOptions.forEach(function (item) {
          item.classList.remove("is-selected");
        });
        if (caffeineContinueButton) {
          caffeineContinueButton.disabled = true;
        }

        if (sportContinueButton) {
          sportContinueButton.disabled = false;
        }
      });
    });

    /*
     * SPORT EXTRA → FLAVOUR
     *
     * Sport never goes through the Caffeine screen: the
     * sub-level answer directly resolves the product line.
     */
    if (sportContinueButton) {
      sportContinueButton.addEventListener("click", function () {
        if (!quizState.sportLevel) return;

        // Changes Oscar 21-10: el amateur pasa por la pregunta de cafeina.
        if (quizState.sportLevel === "amateur") {
          showScreen(3);
          return;
        }

        showFlavourGroup(getProductLine());
        showScreen(4);
      });
    }

    if (sportBackButton) {
      sportBackButton.addEventListener("click", function () {
        quizState.sportLevel = null;

        if (sportContinueButton) {
          sportContinueButton.disabled = true;
        }

        sportOptions.forEach(function (item) {
          item.classList.remove("is-selected");
        });

        showScreen(2);
      });
    }

    /*
     * SCREEN 4
     * FLAVOUR SELECTION (single-select)
     */

    flavourOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        const group = option.closest("[data-flavour-group]");

        if (group) {
          group
            .querySelectorAll(".quiz-flavour-option")
            .forEach(function (item) {
              item.classList.remove("is-selected");
            });
        }

        option.classList.add("is-selected");

        quizState.flavour = option.dataset.flavour;

        if (flavourContinueButton) {
          flavourContinueButton.disabled = false;
        }
      });
    });

    /*
     * FLAVOUR → CONSUMPTION
     */
    if (flavourContinueButton) {
      flavourContinueButton.addEventListener("click", function () {
        if (!quizState.flavour) return;

        showScreen(5);
      });
    }

    /*
     * BACK FROM FLAVOUR
     *
     * For SPORT → return to Sport Extra Question
     * For ENERGY / CREAM → return to Caffeine (screen 3)
     */

    const backFromFlavour = quiz.querySelector("[data-back-screen]");

    if (backFromFlavour) {
      backFromFlavour.addEventListener("click", function () {
        if (quizState.baseLine === "SPORT" && quizState.sportLevel !== "amateur") {
          showSportScreen();
        } else {
          showScreen(3);
        }
      });
    }

    /*
     * SCREEN 3
     * CAFFEINE
     */

    const caffeineOptions = quiz.querySelectorAll(".quiz-caffeine-option");

    caffeineOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        caffeineOptions.forEach(function (item) {
          item.classList.remove("is-selected");
        });

        option.classList.add("is-selected");

        quizState.caffeine = option.dataset.caffeine;

        if (caffeineContinueButton) {
          caffeineContinueButton.disabled = false;
        }
      });
    });

    if (caffeineContinueButton) {
      caffeineContinueButton.addEventListener("click", function () {
        if (!quizState.caffeine) return;

        showFlavourGroup(getProductLine());
        showScreen(4);
      });
    }

    /*
     * BACK FROM CAFFEINE
     */
    const backFromCaffeine = quiz.querySelector("[data-back-caffeine]");

    if (backFromCaffeine) {
      backFromCaffeine.addEventListener("click", function () {
        if (quizState.baseLine === "SPORT") {
          showSportScreen();
          return;
        }
        showScreen(2);
      });
    }

    /*
     * SCREEN 5
     * CONSUMPTION
     */

    const consumptionOptions = quiz.querySelectorAll(
      ".quiz-consumption-option",
    );

    const consumptionContinueButton = quiz.querySelector(
      "[data-continue-consumption]",
    );

    consumptionOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        consumptionOptions.forEach(function (item) {
          item.classList.remove("is-selected");
        });

        option.classList.add("is-selected");

        quizState.consumption = option.dataset.consumption;

        if (consumptionContinueButton) {
          consumptionContinueButton.disabled = false;
        }
      });
    });

    /*
     * CONSUMPTION → EMAIL
     */
    if (consumptionContinueButton) {
      consumptionContinueButton.addEventListener("click", function () {
        if (!quizState.consumption) return;

        showScreen(6);
      });
    }

    const backFromConsumption = quiz.querySelector("[data-back-consumption]");

    if (backFromConsumption) {
      backFromConsumption.addEventListener("click", function () {
        /*
         * Consumption is only ever reached after the
         * Flavour screen (RESET / TASTING_PACK skip it
         * entirely), so Back always returns there.
         */
        showScreen(4);
      });
    }

    /*
     * SCREEN 6
     * EMAIL
     */
    async function subscribeEmailToKlaviyo(email) {
      const KLAVIYO_PUBLIC_KEY = "K5rAdb";
      const KLAVIYO_LIST_ID = "NgNjAg";

      const response = await fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(KLAVIYO_PUBLIC_KEY)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/vnd.api+json",
            Accept: "application/vnd.api+json",
            revision: "2026-01-15",
          },
          body: JSON.stringify({
            data: {
              type: "subscription",
              attributes: {
                profile: {
                  data: {
                    type: "profile",
                    attributes: {
                      email: email,
                      subscriptions: {
                        email: {
                          marketing: {
                            consent: "SUBSCRIBED",
                          },
                        },
                      },
                    },
                  },
                },
              },
              relationships: {
                list: {
                  data: {
                    type: "list",
                    id: KLAVIYO_LIST_ID,
                  },
                },
              },
            },
          }),
        },
      );

      if (!response.ok) {
        const error = await response.text();
        throw new Error(`Klaviyo error: ${error}`);
      }

      return response;
    }

    const emailForm = quiz.querySelector("[data-quiz-email-form]");
    const emailInput = quiz.querySelector("[data-email-input]");
    const emailContinueButton = quiz.querySelector("[data-continue-email]");
    const emailSkipButton = quiz.querySelector("[data-skip-email]");
    
    const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    function applyCustomValidity() {
      if (!emailInput) return;

      if (emailInput.value && !EMAIL_REGEX.test(emailInput.value.trim())) {
        emailInput.setCustomValidity(zdT('quizEmailInvalid'));
      } else {
        emailInput.setCustomValidity('');
      }
    }
    
    if (emailInput && emailContinueButton) {
      emailContinueButton.disabled = !emailInput.value.trim();

      emailInput.addEventListener('input', function () {
        emailContinueButton.disabled = !emailInput.value.trim();

        emailInput.setCustomValidity('');
      });
    }

    if (emailForm) {
        emailForm.addEventListener('submit', async function (event) {
            event.preventDefault();
            const email = emailInput.value.trim();
            applyCustomValidity();
            if (!emailInput.checkValidity()) {
                emailInput.reportValidity();
                return;
            }

            emailContinueButton.disabled = true;

            try {
                await subscribeEmailToKlaviyo(email);
                quizState.email = email;
                resolveResult();
                showScreen(7);
                renderResult();
                qrEmailNotice();

            } catch (error) {
                console.error('Failed to save email to Klaviyo:', error);
                quizState.email = email;
                resolveResult();
                showScreen(7);
                renderResult();
            } finally {
                emailContinueButton.disabled = false;
            }
        });
    }

    // Changes Oscar 21-10: aviso de que el descuento va al correo (como en cualquier newsletter).
    function qrEmailNotice() {
      const wrap = quiz.querySelector(".qr-wrap");
      if (!wrap || wrap.querySelector(".qr-email-notice")) return;
      const box = document.createElement("div");
      box.className = "qr-email-notice";
      box.setAttribute("role", "status");
      box.innerHTML = zdT('quizEmailNotice');
      box.style.cssText = "display:flex;flex-direction:column;gap:2px;max-width:720px;margin:0 auto 16px;padding:12px 16px;border:1px solid #090909;border-radius:12px;background:#c5ff00;color:#090909;font-size:14px;line-height:20px;text-align:center";
      const title = wrap.querySelector(".qr-title");
      if (title && title.nextSibling) wrap.insertBefore(box, title.nextSibling); else wrap.prepend(box);
    }

    if (emailSkipButton) {
      emailSkipButton.addEventListener("click", function () {
        quizState.email = null;
        resolveResult();
        showScreen(7);
        renderResult();
      });
    }

    /*
     * RESULT RESOLUTION
     *
     * Priority:
     *
     * 1. Tasting Pack
     * 2. RESET
     * 3. line + flavour combo key, e.g. "ENERGY_FRESH",
     *    "CREAM_CHOCOLATE", "HYDRIZE_CITRUS", "IGNITION_INTENSE"
     *
     * IGNITION now also splits by flavour (Fresh / Fruity /
     * Intense), same as the other lines — it is no longer a
     * single fixed product.
     *
     * Always recomputed from the live quizState rather than
     * trusting a value set earlier in the flow.
     */
    function resolveResult() {
      if (quizState.goal === "tasting-pack") {
        quizState.result = "TASTING_PACK";
        return;
      }

      if (quizState.goal === "reset") {
        quizState.result = "RESET";
        return;
      }

      const line = getProductLine();

      if (line && quizState.flavour) {
        quizState.result = line + "_" + quizState.flavour.toUpperCase();
        return;
      }

      quizState.result = line;
    }

    /*
     * Optional helper:
     * If Screen 7 needs to know the final recommendation
     */
    function getResultData() {
      return {
        result: quizState.result,
        flavour: quizState.flavour,
        consumption: quizState.consumption,
      };
    }

    function updatePurchaseFormat() {
      const activeCard = quiz.querySelector("[data-result-card].is-active");

      if (!activeCard) return;

      const formatBlocks = activeCard.querySelectorAll(
        "[data-purchase-format]",
      );

      if (formatBlocks.length === 0) return;

      formatBlocks.forEach(function (block) {
        const format = block.dataset.purchaseFormat;
        const matches = format === quizState.consumption;

        block.hidden = !matches;
      });
    }

    function renderResult() {
      const resultCards = quiz.querySelectorAll("[data-result-card]");

      const altGroups = quiz.querySelectorAll("[data-result-alt-group]");

      /*
       * Hide all result cards + alternative lists first
       */
      resultCards.forEach(function (card) {
        card.hidden = true;
        card.classList.remove("is-active");
      });

      altGroups.forEach(function (group) {
        group.hidden = true;
      });

      /*
       * Show the matching result card
       */
      const resultCard = quiz.querySelector(
        '[data-result-card="' + quizState.result + '"]',
      );

      if (resultCard) {
        resultCard.hidden = false;
        resultCard.classList.add("is-active");

        /*
         * Re-apply the Consumption-based defaults (purchase
         * option + quantity) now that quizState.consumption is
         * actually known — at JS init time it wasn't yet, so
         * every selector defaulted to Compra única + 1 bote.
         */
        const subscriptionSelector = resultCard.querySelector(
          "[data-subscription-selector]",
        );

        if (subscriptionSelector && subscriptionSelector.applyDefaults) {
          subscriptionSelector.applyDefaults();
        }
      }

      /*
       * Show the matching alternatives list
       */
      const alternatives = quiz.querySelector("[data-result-alternatives]");
      const altGroup = quiz.querySelector(
        '[data-result-alt-group="' + quizState.result + '"]',
      );

      if (alternatives) {
        alternatives.hidden = !altGroup;
      }

      if (altGroup) {
        altGroup.hidden = false;
      }

      updatePurchaseFormat();
      renderResultNote();
      updateResultPrice(resultCard);
    }

    /*
     * Changes Oscar 21-10: precio del resultado segun cantidad y tipo de
     * compra. Compra unica: descuento por cantidad de la web nueva (botes
     * Óscar 28/10: botes de Energy, Cream, Hydrize e Ignition y Reset, todos
     * 2 = -5%, 3 = -10%, 4 o mas = -15%;
     * son los descuentos automaticos de Shopify). Suscripcion:
     * descuento del plan elegido (los de cantidad no aplican a suscripcion).
     * Se tacha el precio sin descuento y se muestra "Ahorras X"; en el pack
     * degustacion la referencia es "Por separado" y no se tacha.
     */
    const QTY_TIERS = [
      { min: 2, pct: 5 },
      { min: 3, pct: 10 },
      { min: 4, pct: 15 },
    ];
    const QTY_TIERS_RESET = [
      { min: 2, pct: 5 },
      { min: 3, pct: 10 },
      { min: 4, pct: 15 },
    ];
    function qrTiersFor(key) {
      return key === "RESET" ? QTY_TIERS_RESET : QTY_TIERS;
    }

    // Óscar 22/10: el tramo cuenta tambien los botes que ya hay en la cesta
    // (compra unica): bebidas = tipo «Tubo», Reset = «gominolas».
    const qrCartBase = { Tubo: 0, gominolas: 0 };
    function qrBaseFor(key) {
      if (key === "RESET") return qrCartBase.gominolas;
      return /^(ENERGY|CREAM|HYDRIZE|IGNITION)_/.test(key) ? qrCartBase.Tubo : 0;
    }
    function qrTierPct(n, key) {
      let pct = 0;
      qrTiersFor(key).forEach(function (tier) { if (n >= tier.min) pct = tier.pct; });
      return pct;
    }
    function qrRefreshCartBase() {
      fetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || "/") + "cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          const next = { Tubo: 0, gominolas: 0 };
          (cart.items || []).forEach(function (i) {
            if (i.selling_plan_allocation || !(i.final_line_price > 0)) return;
            const t = String(i.product_type || "").toLowerCase();
            if (t === "tubo") next.Tubo += i.quantity;
            else if (t === "gominolas") next.gominolas += i.quantity;
          });
          if (next.Tubo === qrCartBase.Tubo && next.gominolas === qrCartBase.gominolas) return;
          qrCartBase.Tubo = next.Tubo;
          qrCartBase.gominolas = next.gominolas;
          quiz.querySelectorAll("[data-result-card]").forEach(function (card) {
            if (!card.hidden) updateResultPrice(card);
          });
        })
        .catch(function () {});
    }
    let qrBaseTimer;
    function qrScheduleBase() { clearTimeout(qrBaseTimer); qrBaseTimer = setTimeout(qrRefreshCartBase, 300); }
    document.addEventListener("shapes:cart:afteradditem", qrScheduleBase);
    document.addEventListener("cart:updated", qrScheduleBase);
    window.addEventListener("pageshow", qrScheduleBase);
    qrRefreshCartBase();

    // Plural de la etiqueta de dosis: la traducida usa su plural; las de metacampo, +s.
    function qrPluralLabel(label) {
      const s = window.zdStrings || {};
      if (label === s.serving && s.servings) return s.servings;
      if (label === s.tub && s.tubs) return s.tubs;
      return label + "s";
    }

    function qrMoney(cents) {
      return (Math.round(cents) / 100).toFixed(2).replace(".", ",") + "€";
    }

    function qrParseMoney(text) {
      const match = String(text || "").replace(/\./g, "").match(/(\d+)(?:,(\d{1,2}))?/);
      if (!match) return 0;
      return parseInt(match[1], 10) * 100 + parseInt((match[2] || "0").padEnd(2, "0"), 10);
    }

    // Óscar 21/10: mismas ayudas que en la ficha (etiquetas, escalones,
    // mensaje y €/toma por pedido de la suscripcion).
    function qrRenderExtras(card, d) {
      const perServingEl = card.querySelector("[data-qr-per-serving]");
      const servings = perServingEl ? parseInt(perServingEl.dataset.servings, 10) || 0 : 0;
      const label = (perServingEl && perServingEl.dataset.doseLabel) || zdT("serving") || "toma";
      const totalServings = servings * d.qty;
      if (perServingEl && totalServings > 0) {
        perServingEl.textContent = zdT("quizServingsTotal", { num: totalServings, label: totalServings === 1 ? label : qrPluralLabel(label) });
      }

      const chips = card.querySelector("[data-qr-chips]");
      if (chips) {
        let html = "";
        if (d.subscriptionActive) {
          html += '<span class="qr-chip qr-chip--pink">' + zdT("freeShipping") + "</span>";
        } else if (d.saving > 0) {
          html += '<span class="qr-chip qr-chip--pink">' + zdT("youSave", { amount: qrMoney(d.saving) }) + "</span>";
        }
        if (totalServings > 0) {
          let chipPrice = d.total / totalServings;
          let hasta = false;
          if (d.subscriptionActive) {
            // Mejor precio de la suscripción: el pedido con más descuento.
            let maxP = 0;
            const cyc = card.querySelector("[data-qr-cycles]");
            try { JSON.parse((cyc && cyc.dataset.rewards) || "[]").forEach(function (r) { if ((r.p || 0) > maxP) maxP = r.p; }); } catch (e) {}
            if (maxP > 0) { chipPrice = d.unit * d.qty * (1 - maxP / 100) / totalServings; hasta = true; }
          } else if (d.hasTiers && !card.dataset.qrTouched) {
            const tt = qrTiersFor(d.key);
            const maxT = tt[tt.length - 1].pct;
            chipPrice = d.unit * (1 - maxT / 100) / servings;
            hasta = true;
          }
          html += '<span class="qr-chip qr-chip--lime">' + (hasta ? zdT("upTo", { amount: qrMoney(chipPrice) + "/" + label }) : qrMoney(chipPrice) + "/" + label) + "</span>";
        }
        chips.innerHTML = html;
        chips.hidden = !html;
      }

      const showTiers = d.hasTiers && !d.subscriptionActive;
      const perk = card.querySelector("[data-qr-onetime-perk]");
      const tiers = qrTiersFor(d.key);
      if (perk) {
        perk.textContent = zdT("quizOnetimePerk", { pct: tiers[tiers.length - 1].pct });
        perk.hidden = !d.hasTiers;
      }
      const base = d.base || 0;
      card.querySelectorAll("[data-qr-tier]").forEach(function (el) {
        const btn = el.closest("[data-purchase-quantity]");
        const p = btn ? qrTierPct((parseInt(btn.dataset.purchaseQuantity, 10) || 0) + base, d.key) : 0;
        if (p > 0) el.textContent = "-" + p + "%";
        el.hidden = !showTiers || p <= 0;
      });
      const msg = card.querySelector("[data-qr-tier-msg]");
      if (msg) {
        if (!showTiers) {
          msg.hidden = true;
        } else {
          const totalQty = d.qty + base;
          const prefix = base > 0 ? zdT("tiersCartPrefix", { tubs: base === 1 ? zdT("tubsOne") : zdT("tubsOther", { num: base }) }) + " " : "";
          let next = null;
          for (let i = 0; i < tiers.length; i++) {
            if (totalQty < tiers[i].min) { next = tiers[i]; break; }
          }
          if (next) {
            const missing = next.min - totalQty;
            msg.innerHTML = prefix + zdT(base > 0 ? "tiersAddMoreLower" : "tiersAddMore", {
              tubs: missing === 1 ? zdT("tubsOne") : zdT("tubsOther", { num: missing }),
              pct: next.pct,
            });
          } else {
            msg.innerHTML = prefix + zdT("tiersGotPct", { pct: tiers[tiers.length - 1].pct });
          }
          msg.hidden = false;
        }
      }

      const cycles = card.querySelector("[data-qr-cycles]");
      if (cycles) {
        if (!d.subscriptionActive || !totalServings) {
          cycles.hidden = true;
        } else {
          let rewards = [];
          try { rewards = JSON.parse(cycles.dataset.rewards || "[]"); } catch (e) {}
          const base = d.unit * d.qty;
          cycles.innerHTML = rewards.map(function (r, i) {
            return '<div class="qr-cycle' + (i === 0 ? " is-first" : "") + '">' +
              '<span class="qr-cycle__n">' + ([zdT("order1"), zdT("order2"), zdT("order3")][i] || zdT("orderN", { n: i + 1 })) + "</span>" +
              '<span class="qr-cycle__t">' + r.t + "</span>" +
              '<span class="qr-cycle__d">' + qrMoney(base * (1 - (r.p || 0) / 100) / totalServings) + "/" + label + "</span>" +
              "</div>";
          }).join("");
          cycles.hidden = false;
        }
      }
    }

    function updateResultPrice(card) {
      if (!card) return;

      const row = card.querySelector(".qr-card__price-row");
      const priceEl = row && row.querySelector(".qr-card__price");
      if (!priceEl) return;

      let compareEl = row.querySelector(".qr-card__compare-price");
      let badgeEl = row.querySelector(".qr-card__discount-badge");

      if (!row.dataset.qrUnit) {
        row.dataset.qrUnit = qrParseMoney(priceEl.textContent);
        row.dataset.qrCompare = compareEl ? qrParseMoney(compareEl.textContent) : 0;
      }

      if (!compareEl) {
        compareEl = document.createElement("span");
        compareEl.className = "qr-card__compare-price";
        row.appendChild(compareEl);
      }

      if (!badgeEl) {
        badgeEl = document.createElement("span");
        badgeEl.className = "qr-card__discount-badge";
        badgeEl.innerHTML = '<span class="qr-card__discount-text"></span>';
        row.appendChild(badgeEl);
      }

      const badgeTextEl = badgeEl.querySelector(".qr-card__discount-text") || badgeEl;
      const key = card.dataset.resultCard || "";
      const hasTiers = /^(ENERGY|CREAM|HYDRIZE|IGNITION)_|^RESET$/.test(key);
      const separado = key === "TASTING_PACK";

      const unit = parseInt(row.dataset.qrUnit, 10) || 0;
      const compareUnit = parseInt(row.dataset.qrCompare, 10) || 0;
      const qty = getSelectedQuantity(card);

      const subscriptionActive = !!card.querySelector(
        '[data-purchase-option="subscription"].is-selected',
      );

      let pct = 0;

      if (subscriptionActive) {
        const select = card.querySelector("[data-selling-plan-select]");
        const option = select ? select.options[select.selectedIndex] : null;
        pct = option ? parseInt(option.dataset.discount, 10) || 0 : 0;
      } else if (hasTiers) {
        pct = qrTierPct(qty + qrBaseFor(key), key);
      }

      const total = Math.round(unit * qty * (1 - pct / 100));
      const reference = compareUnit > unit ? compareUnit * qty : unit * qty;
      const saving = reference - total;

      priceEl.textContent = qrMoney(total);

      // Changes Oscar 21-10: precio por toma con la cantidad y el descuento.
      const perServingEl = card.querySelector("[data-qr-per-serving]");
      if (perServingEl) {
        const servings = parseInt(perServingEl.dataset.servings, 10) || 0;
        const label = perServingEl.dataset.doseLabel || zdT("serving") || "toma";
        if (servings > 0 && qty > 0) {
          perServingEl.textContent =
            qrMoney(total / (servings * qty)) + "/" + label +
            " · " + servings * qty + " " + qrPluralLabel(label);
          perServingEl.hidden = false;
        } else {
          perServingEl.hidden = true;
        }
      }

      if (saving > 0) {
        compareEl.textContent = (separado ? zdT("separately") + " " : "") + qrMoney(reference);
        compareEl.style.textDecoration = separado ? "none" : "";
        compareEl.hidden = false;
        badgeTextEl.textContent = zdT("youSave", { amount: qrMoney(saving) });
        badgeEl.hidden = false;
      } else {
        compareEl.hidden = true;
        badgeEl.hidden = true;
      }

      qrRenderExtras(card, {
        hasTiers: hasTiers,
        key: key,
        base: hasTiers && !subscriptionActive ? qrBaseFor(key) : 0,
        subscriptionActive: subscriptionActive,
        qty: qty,
        total: total,
        saving: saving,
        unit: unit,
      });
    }

    quiz.addEventListener("click", function (event) {
      // Óscar 25/10: como en la ficha, «Hasta X €/toma» en compra única
      // hasta que el cliente toca la cantidad.
      const qtyBtn = event.target.closest("[data-purchase-quantity]");
      const qtyCard = qtyBtn && qtyBtn.closest("[data-result-card]");
      if (qtyCard) qtyCard.dataset.qrTouched = "1";
      if (
        event.target.closest("[data-purchase-quantity]") ||
        event.target.closest("[data-purchase-option]")
      ) {
        updateResultPrice(event.target.closest("[data-result-card]"));
      }
    });

    quiz.addEventListener("change", function (event) {
      if (event.target.closest("[data-selling-plan-select]")) {
        updateResultPrice(event.target.closest("[data-result-card]"));
      }
    });

    /*
     * Changes Oscar 21-10: nota bajo el titulo del resultado.
     * - Cafeina "moderada" en Energy / Cream: mismo producto, empezar
     *   con medio cazo.
     * - Batido + "poco o nada": no hay batido sin cafeina, se explica
     *   por que el match es Hydrize.
     */
    function renderResultNote() {
      const resultScreen = quiz.querySelector('[data-screen="7"]');
      if (!resultScreen) return;

      let note = resultScreen.querySelector("[data-quiz-result-note]");
      if (!note) {
        note = document.createElement("p");
        note.setAttribute("data-quiz-result-note", "");
        note.className = "quiz-question__subtitle";
        note.style.textAlign = "center";
        note.style.margin = "8px auto 16px";
        note.style.maxWidth = "560px";
        const title = resultScreen.querySelector(".quiz-result__title");
        if (title && title.parentNode) {
          title.parentNode.insertBefore(note, title.nextSibling);
        } else {
          resultScreen.prepend(note);
        }
      }

      const line = getProductLine();
      let text = "";

      if (quizState.baseLine === "CREAM" && quizState.caffeine === "little") {
        text = zdT("quizNoteCreamCaffeine");
      } else if (quizState.caffeine === "moderate" && (line === "ENERGY" || line === "CREAM")) {
        text = zdT("quizNoteHalfScoop");
      }

      note.textContent = text;
      note.hidden = !text;
    }

    /*
     * RESULT CARD — SUBSCRIPTION SELECTOR
     * (Compra única / Suscríbete, quantity, frequency)
     *
     * Every result card has its own independent selector,
     * since all cards live in the DOM at once (only one is
     * shown at a time via [hidden] on [data-result-card]).
     * So everything here is scoped per-card, not global.
     */
    const subscriptionSelectors = quiz.querySelectorAll(
      "[data-subscription-selector]",
    );

    function defaultQuantityFromConsumption() {
      switch (quizState.consumption) {
        case "occasionally":
          return 1;
        case "daily":
          return 2;
        case "regular":
          return 2;
        default:
          return 1;
      }
    }

    subscriptionSelectors.forEach(function (selector) {
      const purchaseOptions = selector.querySelectorAll(
        "[data-purchase-option]",
      );
      const quantityOptions = selector.querySelectorAll(
        "[data-purchase-quantity]",
      );
      const frequencyField = selector.querySelector("[data-frequency-field]");
      const sellingPlanSelect = selector.querySelector(
        "[data-selling-plan-select]",
      );
      const selectedSellingPlanInput = selector.querySelector(
        "[data-selected-selling-plan]",
      );
      const discountBadge = selector.querySelector(
        "[data-subscription-discount]",
      );
      const discountBadgeText = discountBadge?.querySelector(
        ".qr-subscription__discount-text",
      );

      function updateDiscountBadge() {
        if (!discountBadge || !sellingPlanSelect) return;

        const selectedOption =
          sellingPlanSelect.options[sellingPlanSelect.selectedIndex];

        const discount = selectedOption
          ? parseInt(selectedOption.dataset.discount, 10) || 0
          : 0;

        if (discount > 0) {
          discountBadge.hidden = false;

          if (discountBadgeText) {
            discountBadgeText.textContent = `-${discount}%`;
          }
        } else {
          discountBadge.hidden = true;
        }
      }

      function setPurchaseOption(option) {
        purchaseOptions.forEach(function (btn) {
          btn.classList.toggle(
            "is-selected",
            btn.dataset.purchaseOption === option,
          );
        });

        if (option === "subscription") {
          if (frequencyField) frequencyField.hidden = false;

          if (selectedSellingPlanInput) {
            selectedSellingPlanInput.value = sellingPlanSelect
              ? sellingPlanSelect.value
              : "";
          }
        } else {
          if (frequencyField) frequencyField.hidden = true;

          if (selectedSellingPlanInput) {
            selectedSellingPlanInput.value = "";
          }
        }
      }

      purchaseOptions.forEach(function (btn) {
        btn.addEventListener("click", function () {
          setPurchaseOption(btn.dataset.purchaseOption);
        });
      });

      if (sellingPlanSelect) {
        sellingPlanSelect.addEventListener("change", function () {
          if (selectedSellingPlanInput) {
            selectedSellingPlanInput.value = sellingPlanSelect.value;
          }

          updateDiscountBadge();
        });
      }

      quantityOptions.forEach(function (btn) {
        btn.addEventListener("click", function () {
          quantityOptions.forEach(function (item) {
            item.classList.remove("is-selected");
          });

          btn.classList.add("is-selected");
        });
      });

      function applyDefaults() {
        const hasSubscriptionOption = !!selector.querySelector(
          '[data-purchase-option="subscription"]',
        );

        /*
         * "Regular" consumption signals a frequent buyer, so
         * default them straight into Suscríbete when the
         * product actually has a subscription option.
         * Everyone else defaults to Compra única.
         */
        const shouldDefaultToSubscription =
          quizState.consumption === "regular" && hasSubscriptionOption;

        setPurchaseOption(
          shouldDefaultToSubscription ? "subscription" : "one-time",
        );

        updateDiscountBadge();

        const defaultQuantity = defaultQuantityFromConsumption();

        quantityOptions.forEach(function (btn) {
          btn.classList.toggle(
            "is-selected",
            parseInt(btn.dataset.purchaseQuantity, 10) === defaultQuantity,
          );
        });
      }

      /*
       * Exposed so renderResult() can re-apply the right
       * defaults once quizState.consumption is actually known
       * (at init time, before the shopper reaches Screen 5,
       * it isn't yet).
       */
      selector.applyDefaults = applyDefaults;

      applyDefaults();
    });

    function getSelectedQuantity(card) {
      const active = card.querySelector("[data-purchase-quantity].is-selected");

      if (active) {
        return parseInt(active.dataset.purchaseQuantity, 10) || 1;
      }

      return defaultQuantityFromConsumption();
    }

    function getSelectedSellingPlan(card) {
      const input = card.querySelector("[data-selected-selling-plan]");

      return input && input.value ? input.value : null;
    }

    async function addResultProductToCart(button) {
      const variantId = button.dataset.productId;

      if (!variantId) return;

      const card = button.closest("[data-result-card]");

      button.disabled = true;

      const quantity = card
        ? getSelectedQuantity(card)
        : defaultQuantityFromConsumption();
      const sellingPlan = card ? getSelectedSellingPlan(card) : null;

      const formData = new FormData();

      formData.append("id", variantId);
      formData.append("quantity", quantity);

      if (sellingPlan) {
        formData.append("selling_plan", sellingPlan);
      }

      const modalCart = theme.settings.cartType === "modal";

      if (modalCart) {
        formData.append("sections", "cart-items,cart-footer,cart-item-count");

        formData.append("sections_url", window.location.pathname);
      }

      const config = fetchConfigDefaults("application/javascript");

      config.body = formData;
      config.headers["X-Requested-With"] = "XMLHttpRequest";

      delete config.headers["Content-Type"];

      try {
        const response = await fetch(theme.routes.cart_add_url, config);

        const data = await response.json();

        if (data.status) {
          console.error(data.description || data.message);

          return;
        }

        /*
         * Open / update Cart Drawer
         */
        if (modalCart) {
          document.body.dispatchEvent(
            new CustomEvent("shapes:cart:afteradditem", {
              bubbles: true,
              detail: {
                response: data,
                sourceId: "quiz-result",
              },
            }),
          );
        }
      } catch (error) {
        console.error("Result add to cart error:", error);
      } finally {
        button.disabled = false;
      }
    }
    const resultAddButtons = quiz.querySelectorAll("[data-result-add]");

    resultAddButtons.forEach((button) => {
      button.addEventListener("click", () => {
        addResultProductToCart(button);
      });
    });

    /*
     * Expose result data for debugging / Screen 7
     */
    quiz.getQuizResult = function () {
      return getResultData();
    };

    const restartButton = quiz.querySelector("[data-quiz-restart]");

    if (restartButton) {
      restartButton.addEventListener("click", function () {
        resetQuizState();

        goalOptions.forEach(function (item) {
          item.classList.remove("is-selected");
        });

        flavourOptions.forEach(function (item) {
          item.classList.remove("is-selected");
        });

        flavourGroups.forEach(function (group) {
          group.hidden = true;
        });

        caffeineOptions.forEach(function (item) {
          item.classList.remove("is-selected");
        });

        sportOptions.forEach(function (item) {
          item.classList.remove("is-selected");
        });

        consumptionOptions.forEach(function (item) {
          item.classList.remove("is-selected");
        });

        if (goalContinueButton) {
          goalContinueButton.disabled = true;
        }

        if (flavourContinueButton) {
          flavourContinueButton.disabled = true;
        }

        if (caffeineContinueButton) {
          caffeineContinueButton.disabled = true;
        }

        if (sportContinueButton) {
          sportContinueButton.disabled = true;
        }

        if (consumptionContinueButton) {
          consumptionContinueButton.disabled = true;
        }

        if (emailInput) {
          emailInput.value = "";
        }

        if (emailContinueButton) {
          emailContinueButton.disabled = true;
        }

        showScreen(1);
      });
    }

    /*
     * INITIALIZE
     */
    updateProgress(1);

    window.zDrinksQuiz = quizState;
  }

  /*
   * INIT ALL QUIZZES
   */
  function initAllQuizzes() {
    const quizzes = document.querySelectorAll("[data-quiz-flow]");

    quizzes.forEach(function (quiz) {
      initQuiz(quiz);
    });
  }

  /*
   * DOM READY
   */
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAllQuizzes);
  } else {
    initAllQuizzes();
  }

  /*
   * SHOPIFY SECTION LOAD
   */
  document.addEventListener("shopify:section:load", function (event) {
    const quiz = event.target.querySelector("[data-quiz-flow]");

    if (quiz) {
      initQuiz(quiz);
    }
  });
})();
